import { Component, OnInit, Input, Output, Inject, EventEmitter  } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IcecontrolSettings, iceColumnDefinition } from '../../components/models/icesettings';
import { Iceutility } from '../../services/iceutility';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcematgridComponent } from '../icepanel/icematgrid.component';

@Component({
  selector: 'iceslidetoggle',
  templateUrl: './iceslidetoggle.component.html',
  styleUrls: ['./iceslidetoggle.component.css'],
  providers: [IcematgridComponent]
})
export class IceslidetoggleComponent implements OnInit {

  color = 'accent';
  // Input Members
  @Input() placeholder: string = "";
  @Input() id: string = "";
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;
  @Input() tableColumn: iceColumnDefinition = null;
  @Input() tableRowData: any = null;
  @Input() matTableObject: IcematgridComponent = null;

  // Output Members
  @Output() buttonChange: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iceFormControl: FormControl = null;

  constructor(
    @Inject(IcepanelComponent) private parent: IcepanelComponent,
    @Inject(IcematgridComponent) private parentTable: IcematgridComponent) {
  }

  ngOnInit() {
    try {
      // To do fix with validation
      if (this.parentTable && this.tableRowData != null && this.tableColumn != null) {
        // tables should not use the standard formcontrol
        let formRowGroup: FormGroup = this.parentTable.getFormGroup(this.tableRowData);
        this.iceFormControl = new FormControl(this.tableRowData[this.tableColumn.columnName]);
        formRowGroup.addControl(this.tableColumn.columnName, this.iceFormControl);
      }
      else {
        // stardard formcontrol processing
        this.iceFormControl = this.ctrl.getFormControl();
        if (this.iceFormControl == null)
          this.iceFormControl = new FormControl(false); // No control so we create a placeholder control to prevent an errors
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  getDisplayValue(lkMode?: string): string {
    let val = false;
    if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
      val = this.tableRowData[this.tableColumn.columnName];
    }
    else {
      val = this.iceFormControl.value;
    }

    let placeHolder = this.getPlaceholder();
    if (this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties
      && (this.ctrl.properties.onDisplayValue != null || this.ctrl.properties.offDisplayValue))
      return placeHolder + (Iceutility.toBoolean(val) ? " " + this.ctrl.properties.onDisplayValue : " " + this.ctrl.properties.offDisplayValue);

    return placeHolder + Iceutility.toBoolean(val) ? " On" : " Off";
  }

  getPlaceholder(): string {
    return this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties.placeholder != null ? this.ctrl.properties.placeholder : "";
  }

  onChange(event) {
    event.buttonSettings = this.ctrl;
    if (this.parentTable && this.parentTable.controlChange) {
      if (this.tableRowData != null && this.tableColumn != null) {
        this.tableRowData[this.tableColumn.columnName] = event.checked;
        event.tableColumn = this.tableColumn;
        event.tableRowData = this.tableRowData;
      }

      this.parentTable.onControlChange(event);
    }
    else if (this.parent && this.parent.controlChange)
      this.parent.onControlChange(event);

    this.buttonChange.emit(event);
  }
}
